/* BELLA NOTTE — עותק אחד מכל כרטיס.
   העגלה ועמוד המוצר מרנדרים בלוקים ביותר מפעם אחת (מגירה + עמוד,
   דסקטופ + מובייל). מעדיפים את העותק שבסיכום העגלה.

   הרצה: מיד, ואז בזמנים קבועים + מצער (throttle) על שינויי DOM.
   בעבר היה כאן debounce שנדחק ללא סוף בעמודים שבהם ה-DOM משתנה
   בלי הפסקה (קרוסלות, טעינה עצלה) — והפונקציה לא רצה אף פעם. */
(function () {
  if (window.__bnDedupe) return;
  window.__bnDedupe = true;

  var CARDS = ['bn-cart-save', 'bn-gift', 'bn-up', 'bn-save', 'bn-gift-note', 'bn-sg'];
  var PREFER = '.cart-summary__inner, cart-summary, .cart-drawer__summary';

  function visible(el) {
    return el.offsetParent !== null || el.getClientRects().length > 0;
  }

  function dedupe() {
    CARDS.forEach(function (cls) {
      var all = Array.prototype.slice.call(document.getElementsByClassName(cls));
      var live = all.filter(function (el) {
        return el.dataset.bnDup !== '1' && visible(el);
      });
      if (live.length < 2) return;

      var preferred = live.filter(function (el) { return el.closest(PREFER); });
      var keep = preferred.length ? preferred[0] : live[0];

      live.forEach(function (el) {
        if (el === keep) return;
        el.dataset.bnDup = '1';
        el.style.display = 'none';
      });
    });

    /* דיאלוג טבלת המידות — משאירים אחד בלבד ב-DOM */
    var dialogs = document.querySelectorAll('[data-bn-sg-dialog]');
    for (var i = 1; i < dialogs.length; i++) {
      if (dialogs[i].parentNode) dialogs[i].parentNode.removeChild(dialogs[i]);
    }
  }

  function safeDedupe() {
    try { dedupe(); } catch (e) {}
  }

  /* הרצה מיידית + בזמנים קבועים, ללא תלות במשקיף */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeDedupe);
  } else {
    safeDedupe();
  }
  [150, 400, 900, 1800, 3000].forEach(function (ms) { setTimeout(safeDedupe, ms); });
  window.addEventListener('load', safeDedupe);

  /* מצער אמיתי: לכל היותר פעם ב-250ms, אבל תמיד רץ */
  var last = 0;
  var pending = null;
  function throttled() {
    var now = Date.now();
    if (now - last >= 250) {
      last = now;
      safeDedupe();
      return;
    }
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      last = Date.now();
      safeDedupe();
    }, 250 - (now - last));
  }

  new MutationObserver(throttled).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cart:update', throttled);
  document.addEventListener('variant:update', throttled);
})();
